export const getQueryString = (params: any) => {
  let query = "?";

  for (const [key, value] of Object.entries(params)) {
    query += `${key}=${value}&`;
  }
  query = query.slice(0, -1);

  return query;
};

export const formatString = (str: string) => {
  return str
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

/**
 * Extracts the career level number from the format "{name} ({number})"
 * Example: "Senior Manager (4)" returns "4"
 * Falls back to extracting all digits if format doesn't match
 */
export const extractCareerLevelNumber = (careerLevel: string | undefined | null): string => {
  if (!careerLevel) return "";
  
  // Try to extract number from parentheses format: "Name (number)"
  const match = careerLevel.match(/\((\d+)\)/);
  if (match && match[1]) {
    return match[1];
  }
  
  // Fallback: extract all digits (for backward compatibility)
  return careerLevel.replace(/\D/g, "");
};
